module.exports = __webpack_public_path__ + "static/media/notification-icon.593508a0.svg";